import { mapActions, mapGetters } from "vuex";

module.exports = {
  computed: {
    ...mapGetters([
      'getLoggedInUser',
      'getLoggedInUserId'
    ])
  },
  watch: {
    getLoggedInUserId(id) {
      this.loggedIn(id);
    },
    getLoggedInUser: {
      handler: function(user, oldVal) {
        if (user && user.name.trim() === "") {
          this.$router.replace({ path: "/editprofile" });
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(["watchLoggedInUser"]),
    loggedIn: function(uid) {
      this.watchLoggedInUser(uid);
    }
  }
};
